import axios from "axios";

class VoteService {
    private VOTE_API_URL = "https://p.kinosvitlo.com/db/";

    async submitVote(day: number, movie: string) {
        const data = new FormData();
        data.append("fest", "6");
        data.append("day", String(day));
        data.append("movie", movie);

        try {
            const response = await axios.post(`${this.VOTE_API_URL}setVote.php`, data);

            if (response.status !== 200) {
                throw new Error(`Error submitting vote: ${response.statusText}`);
            }

            return true;
        } catch (error) {
            console.error("Failed to submit vote:", error);
            throw error;
        }
    }
}

const voteService = new VoteService();
export default voteService;
